/**
 * @module components\ghModelView\propView
 */
import { CreateElement } from "vue";
import Component from "vue-class-component";

import Check from "./templates/check/check";
import Base from "./base";
import TextInput from "./templates/textInput/textInput";
import NumberInput from "./templates/numberInput/numberInput";
import DateInpute from "./templates/dateInpute/dateInpute";
import Selection from "./templates/selection/selection";
import TextArea from "./templates/textArea/textArea";

@Component({
  components: {
    ["gh-boolean"]: Check,
    ["gh-string"]: TextInput,
    ["gh-number"]: NumberInput,
    ["gh-date"]: DateInpute,
    ["gh-selection"]: Selection,
    ["gh-textarea"]: TextArea
  }
})
export default class PropView extends Base {
  private map = {
    ["boolean"]: "gh-boolean",
    ["string"]: "gh-string",
    ["number"]: "gh-number",
    ["date"]: "gh-date",
    ["selection"]: "gh-selection",
    ["textarea"]: "gh-textarea"
  };
  render(h: CreateElement) {
    let type: string = this.prop.type as string;
    let el = "gh-string";
    if (this.map[type]) {
      el = this.map[type];
    }
    if (this.readonly) {
      this.prop.readonly = this.readonly;
    }

    return h("gh-input", {
      props: {
        prop: this.prop,
        model: this.model,
        
      }
    });
  }
}
